import React from 'react';
import BusJourney from '../components/BusJourney';
import MainSlider from './MainSlider';
// import Services from './Services';
import About from './About';
import HowItWorks from './HowItWorks';
import MobileApps from './MobileApps';
import Counters from './Counters';
import Benefits from './Benefits';
import Testimonials from './Testimonials';
import ContactUs from './ContactUs';
import { ClientsSection } from './OurClients';


import Services from './Services';



// Home Component
const Home = () => {
    return (
        <>
            {/* Main Slider */}
            <MainSlider />
          

            {/* Some Services */}
            <Services />

            {/* About  */}
            <About />
          

            {/* Work Process */}
            <HowItWorks />
           

            {/* Bus Journey Animation */}
            <BusJourney />
         

            {/* Mobile Apps */}
            <MobileApps />
           

            {/* Counters */}
            <Counters />

            {/* Benefits */}
            <Benefits />

            {/* Clients */}
            <ClientsSection />

            {/* Testimonials */}
            <Testimonials />

            {/* Contact US */}
            <ContactUs />




        </>
    );
};

export default Home;
